"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var defineAction_1 = require("./defineAction");
exports.defineAction = defineAction_1.defineAction;
__export(require("./defineActionGroup"));
//# sourceMappingURL=index.js.map